import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type ReferralBannerState = {
  isDismissed: boolean
  dismissBanner: () => void
  resetBannerState: () => void
}

export const useReferralBannerStore = create<ReferralBannerState>()(
  persist(
    (set) => ({
      isDismissed: false, // Default state is not dismissed
      dismissBanner: () => set({ isDismissed: true }),
      resetBannerState: () => set({ isDismissed: false }),
    }),
    {
      name: 'referral-banner-storage', // unique name for localStorage key
    }
  )
)
